import script from "./supplyAndDemmandCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./supplyAndDemmandCenter.vue?vue&type=script&setup=true&lang=js"

import "./supplyAndDemmandCenter.vue?vue&type=style&index=0&id=207df83b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207df83b"]])

export default __exports__